require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-174-client-portal-manager-access.json") })
        }
      }, "path---article-174-client-portal-manager-access");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-174-client-portal-manager-access!./.cache/json/article-174-client-portal-manager-access.json
// module id = 523
// module chunks = 231608221292675